<template>
  <BaseFrame
    cancelText="取消"
    clearText=""
    submitText="提交申请"
    @submit="toSubmitValidate"
  >
    <div class="container" slot="content">
      <lk-card
        title="返利详情"
      >
        <returnProfitDetail
          ref="returnProfitCon"
          :formObject="detailObject"
          :formRules="rules"
          :fieldData="selectedItem"
          :config="returnProfitContents"
          @change="toGetData"
          @add="selected"
          @attach="toAttach"
          @selectChange="handleSelectChange"
        >
        </returnProfitDetail>
      </lk-card>
    </div>
  </BaseFrame>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import returnProfitDetail from '../../components/returnProfitDetail.vue';
import system from '../../services/system';
import finance from '../../services/finance';
import goods from '../../services/goods';
import utils from '../../libs/utils';

export default {
  name: 'otherProfitLogAdd',
  components: {
    BaseFrame,
    returnProfitDetail
  },
  data() {
    return {
      detailObject: {
        storeId: null,
        supplierStoreId: null,
        goods: '',
        inspectionCode: '',
        rebateWay: '',
        rebateAmount: null,
        remark: '',
      },
      rules: {
        storeId: [{ required: true, message: '请选择门店', type: 'number'}],
        supplierStoreId: [{ required: true, message: '请选择供应商', type: 'number'}],
        inspectionCode: [{ required: true, message: '请输入验收单号'}],
        rebateWay: [{ required: true, message: '请输入返利方式'}],
        rebateAmount: [{ required: true, message: '请输入返利金额'}]
      },
      selectedItem: {},
      returnProfitContents: [
        [
          {
            type: 'select',
            filterable: true,
            title: '门店',
            prop: "storeId",
            style: 'width: 50%;',
            key: 'storeId',
            idKey: 'id',
            nameKey: 'name',
            options: [],
          },
          {
            type: 'select',
            title: '供应商',
            prop: "supplierStoreId",
            filterable: true,
            style: 'width: 50%;',
            key: 'supplierStoreId',
            idKey: 'supplierId',
            nameKey: 'supplierName',
            options: [],
          },
        ],
        [
          {
            type: 'inputSearch',
            title: '商品',
            required: true,
            isShowInputSearch: true,
            style: 'width:50%;display:inline-block;',
            value: '',
            goodsData: [],
            goodsColumns: [
              { title: '商品编码', key: 'drugSerialCode', width: '65px' },
              { title: '药品通用名', key: 'approvedDrugNames', width: '142px' },
              { title: '商品名', key: 'goodsName', width: '90px' },
              { title: '生产厂家', key: 'manufacturer', width: '65px' },
              { title: '规格', key: 'specifications', width: '142px' },
              { title: '包装单位', key: 'drugMiniPackageUnitString', width: '90px' },
            ],
            showFields: [
              {
                title: '商品编码：',
                key: 'drugSerialCode'
              },
              {
                title: '通用名：',
                key: 'approvedDrugNames'
              },
              {
                title: '商品名：',
                key: 'goodsName'
              },
              {
                title: '规格：',
                key: 'specifications'
              },
              {
                title: '包装单位：',
                key: 'drugMiniPackageUnitString'
              },
              {
                title: '生产厂家：',
                key: 'manufacturer'
              },
            ],
          }
        ],
        [
          {
            type: 'select',
            title: '验收单号',
            prop: "inspectionCode",
            placeholder: '请输入',
            style: 'width: 50%;',
            key: 'inspectionCode',
            filterable: true,
            idKey: 'inspectionCode',
            nameKey: 'inspectionCode',
            options: [],
          },
          {
            type: 'input',
            title: '返利方式',
            prop: "rebateWay",
            maxlength: 10,
            placeholder: '请输入',
            style: 'width: 50%;',
            key: 'rebateWay',
          }
        ],
        [
          {
            type: 'inputNumber',
            title: '返利金额',
            active: false,
            max: 999999,
            min: 0,
            precision: 2,
            prop: "rebateAmount",
            placeholder: '请输入',
            style: 'width: 50%;',
            key: 'rebateAmount',
          },
          {
            type: 'upload',
            title: '附件',
            isCanEdit: true,
            uploadInfo: [
              {
                appendixName: '',
                appendixUrl: '',
              },
            ]
          }
        ],
        [
          {
            type: 'input',
            title: '申请备注',
            key: 'remark',
            style: "width:120%",
            inputType: 'textarea',
            rows: 4,
            placeholder: '请输入'
          },
        ]
      ],
      receiptList: [],
    }
  },
  methods: {
    toSubmitValidate() {
      if (!this.selectedItem.drugSerialCode) {
        this.$Message.error('请选择商品');
        return
      }
      this.$refs.returnProfitCon.$refs.form.validate(valid => {
        if (valid) {
          this.submit();
        }
      })
    },
    submit() {
      let { goodsStoreId, id } = this.selectedItem;
      let obj = this.receiptList.find(item => item.inspectionCode === this.detailObject.inspectionCode);
      let info = Object.assign({}, this.detailObject, {goodsStoreId, goodsBaseId:id}, obj);
      const params = {
        financeRebateRecord: info,
        bizExtraVos: this.returnProfitContents[3][1].uploadInfo,
      }
      finance.submitReturnProfit(params).then(res => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          this.$router.push({ name: 'otherProfitLog' });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    toGetData() {
      const params = {
        nameMix: this.returnProfitContents[1][0].value,
        storeId: this.detailObject.storeId,
        page: 1,
        size: 20
      }
      goods.listGoodsStores(params).then(res => {
        if (res.data.status === 200) {
          let data = res.data.data.list || [];
          let list = [];
          data.forEach(item => {
            item.goodsBaseVO.goodsBase.goodsStoreId = item.goodsStore.id;
            list.push(item.goodsBaseVO.goodsBase);
          })
          this.$set(this.returnProfitContents[1][0], 'goodsData', list);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    selected(val) {
      this.selectedItem = val;
      this.$set(this.returnProfitContents[1][0], 'value', '');
      this.$set(this.returnProfitContents[2][0], 'options', []);
      this.detailObject.inspectionCode = null;
      this.toGetReceipt();
    },
    toAttach(val) {
      this.$set(this.returnProfitContents[3][1], 'uploadInfo', val);
    },
    toGetReceipt() {
      if (!this.selectedItem.goodsStoreId || !this.detailObject.supplierStoreId || !this.detailObject.storeId) {
        return
      }
      const params = {
        goodsStoreId: this.selectedItem.goodsStoreId,
        supplierStoreId: this.detailObject.supplierStoreId,
        storeId: this.detailObject.storeId,
      }
      finance.toGetReceipt(params).then(res => {
        if (res.data.status === 200) {
          this.receiptList = res.data.data || [];
          this.$set(this.returnProfitContents[2][0], 'options', this.receiptList);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    toGetStores() {
      system.getBelongStores().then(res => {
        if (res.data.status === 200) {
          this.$set(this.returnProfitContents[0][0], 'options', res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    toGetSuppliers() {
      finance.getSuppliers({ storeId: this.detailObject.storeId }).then(res => {
        if (res.data.status === 200) {
          this.$set(this.returnProfitContents[0][1], 'options', res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    handleSelectChange(key) {
      const list = ['supplierStoreId'];
      if (key === 'storeId') {
        this.toGetSuppliers();
        this.$set(this.detailObject, 'inspectionCode', null);
        this.detailObject.supplierStoreId = null;
        this.$set(this.returnProfitContents[2][0], 'options', []);
        this.$set(this.returnProfitContents[0][1], 'options', []);
        this.selectedItem = {};
      }
      if (list.includes(key)) {
        this.$set(this.returnProfitContents[2][0], 'options', []);
        this.detailObject.inspectionCode = null;
        this.toGetReceipt();
      }
    }
  },
  mounted() {
    this.toGetStores();
  }
}
</script>
<style lang="less" scoped>

</style>